import { createContext } from "react";

const WorksContext = createContext();

export default WorksContext;
